<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
  // import index from './views/index'
  export default{

  }
</script>

<style lang="scss">
  body,div,p,h1,h2,h3,h4,h5,h6,ul,li,dl,dt,a,input,button,textarea,select{
    margin: 0;
    padding: 0;
    outline: none;
  }
  body{
    color: #333333;
    background-color: #f5f6fa;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 400;
    line-height: 1.43;
    min-width: 1226px;
    font-size: 14px;
  }
  a{
    text-decoration: none;
  }
  ul,li{
    list-style: none;
  }
  input:focus,a:focus{
    outline: none;
  }
</style>
